import axios from 'axios'

export const http = axios.create({
  baseURL: process.env['BASE_URL']
})

export default http
export {axios}



// WEBPACK FOOTER //
// ./src/http/index.js